import axios from 'axios';
import { useEffect, useState, useRef, useCallback } from 'react';
import { Room, Track, RoomEvent } from 'livekit-client';
import { useTracks, RoomAudioRenderer, useTranscriptions, RoomContext, VideoTrack, useTrackToggle, TrackToggle } from "@livekit/components-react";
import '@livekit/components-styles';
import { Button, Container, Row, Col, Card, Form, Spinner, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import "bootstrap-icons/font/bootstrap-icons.css";

function AvatarRenderer({ agentName, onStop, loading }) {
    const [isZoom, setIsZoom] = useState(false);
    const trackRefs = useTracks([Track.Source.Camera]);
    const camTrackRef = trackRefs.find(
        (trackRef) => trackRef.participant.name === agentName
    );

    if (!camTrackRef) {
        return (
            <div className="loader">
                <img src="/loader2.gif" alt="loading..." width="250" />
            </div>
            // <div className={`image-wrapper loading`}>
            //     <div
            //         className="col-12 col-md-8 col-lg-12 mx-auto shadow-sm position-relative overflow-hidden mb-4"
            //         style={{
            //             maxHeight: "500px",
            //             aspectRatio: "1/1",
            //             borderRadius: "24px",
            //             backgroundColor: "#f4f6f8",
            //             border: "4px solid white"
            //         }}>
            //         <img
            //             src="/avatar-meera.webp"
            //             alt="AI Recruiter"
            //             style={{
            //                 width: "100%",
            //                 height: "100%",
            //                 objectFit: "cover",
            //             }} />
            //     </div>
            //     <div class={`image-overlay`}>
            //         <img src="/loader2.gif" alt="loading" class="loader" />
            //     </div>
            // </div>
        );
    }

    // Normal View
    if (!isZoom) {
        return (
            <div className="video-wrapper position-relative">
                <VideoTrack
                    trackRef={camTrackRef}
                    className='video-el'
                />
                <RoomAudioRenderer />
                <button className="zoom-btn" onClick={() => setIsZoom(true)}><i className="bi bi-arrows-angle-expand fs-4"></i></button>
            </div>
        );
    }

    // Zoom View
    return (
        <div className="video-zoom-overlay">

            <button className="zoom-close-btn" onClick={() => setIsZoom(false)}> ✕ </button>

            <div className="zoom-controls" style={{ maxWidth: "700px" }}>
                <div className="d-flex align-items-center">
                    <TrackToggle className='bg-light py-3 rounded-circle d-flex align-items-center justify-content-center shadow text-dark' source={Track.Source.Microphone} />
                </div>
                <PauseButton variant='zoom-screen-pause-btn' />
                <Button className='zoom-screen-stop-btn rounded-circle d-flex align-items-center justify-content-center shadow text-light' variant="danger" onClick={onStop} disabled={loading}><i className='bi bi-telephone-x-fill fs-6' /></Button>
            </div>

            <VideoTrack trackRef={camTrackRef} className="zoom-video" />
            <RoomAudioRenderer />
        </div>
    );
}

function ChatBox() {
    const transcriptions = useTranscriptions();
    const boxRef = useRef(null);

    useEffect(() => {
        if (boxRef.current) {
            boxRef.current.scrollTop = boxRef.current.scrollHeight;
        }
    }, [transcriptions]);

    return (
        <div className="p-3 m-2 shadow-sm rounded chat-box" ref={boxRef}>
            {transcriptions.map((transcription) =>
                <div
                    style={{
                        display: "flex",
                        justifyContent: transcription.participantInfo.identity.includes("agent")
                            ? "flex-start"
                            : "flex-end",
                        marginBottom: "10px",
                    }}
                >
                    <div className='text-start'
                        style={{
                            maxWidth: "70%",
                            padding: "10px 14px",
                            borderRadius: "12px",
                            background: transcription.participantInfo.identity.includes("agent")
                                ? "#010958ff" : "#ffffffff",
                            color: transcription.participantInfo.identity.includes("agent") ? "#ffffff" : "#333",
                            fontSize: "14px",
                            lineHeight: "1.4",
                        }}
                    >
                        <strong>
                            {transcription.participantInfo.identity.includes("agent") ? "Agent" : "You"}:
                        </strong>{" "}
                        {transcription.text}
                    </div>
                </div>
            )}
        </div>
    );
}

const PauseButton = ({ variant }) => {

    const { buttonProps, enabled } = useTrackToggle({
        source: Track.Source.Microphone,
        initialState: true
    });

    return (
        <Button variant='dark' onClick={buttonProps.onClick} className={`rounded-circle d-flex align-items-center justify-content-center shadow ${variant ? variant : 'pause-btn'}`}>
            <i className={`bi ${enabled ? "bi-pause-fill" : "bi-play-fill"}`} />
        </Button>
    );
};


function Main(props) {
    const user = props.user;
    axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;

    const [room] = useState(() => new Room({}));
    const [jobs, setJobs] = useState([]);
    const [selectedJob, setSelectedJob] = useState("");

    // Resume State
    const [resumeFile, setResumeFile] = useState(null);
    const [isUploadingResume, setIsUploadingResume] = useState(false);
    const [statusMessage, setStatusMessage] = useState(null);
    const [uploadedResumeName, setUploadedResumeName] = useState(user?.resume_original_filename || "");
    const [resumeVersion, setResumeVersion] = useState(Date.now());
    const fileInputRef = useRef(null);

    // LiveKit State
    const [isStartConversation, setIsStartConversation] = useState(false);
    const [agentName, setAgentName] = useState("");
    const [roomName, setRoomName] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchJobs = async () => {
            try {
                const res = await axios.get('/get_all_jobs', { withCredentials: true });
                if (res.data.status === 'success') {
                    setJobs(res.data.jobs);
                    if (res.data.jobs.length > 0) {
                        setSelectedJob(res.data.jobs[0].id);
                    }
                }
            } catch (err) {
                console.error("Failed to fetch jobs:", err);
            }
        };
        fetchJobs();
    }, []);

    useEffect(() => {
        const handleDisconnect = () => {
            setIsStartConversation(false);
            setLoading(false);
            setStatusMessage({ type: 'info', text: 'Interview ended.' });
        };
        room.on(RoomEvent.Disconnected, handleDisconnect);
        return () => room.off(RoomEvent.Disconnected, handleDisconnect);
    }, [room]);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setResumeFile(e.target.files[0]);
            setStatusMessage(null);
        }
    };

    const handleResumeUpload = async (e) => {
        e.preventDefault();
        if (!resumeFile) {
            setStatusMessage({ type: 'danger', text: "Please select a file first." });
            return;
        }

        setIsUploadingResume(true);
        setStatusMessage({ type: 'info', text: "Uploading and processing your resume. This involves AI extraction and vectorization. Please wait... This may take sometime." });

        const formData = new FormData();
        formData.append("user_id", user.id);
        formData.append("resume", resumeFile);

        try {
            const res = await axios.post('/update_resume', formData, {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true
            });
            if (res.data.status === 'success') {
                setStatusMessage({ type: 'success', text: "Resume updated and securely vectorized! You are ready to interview." });
                setResumeFile(null);
                setUploadedResumeName(resumeFile.name);
                setResumeVersion(Date.now());
                if (fileInputRef.current) fileInputRef.current.value = "";
            }
        } catch (err) {
            console.error(err);
            setStatusMessage({ type: 'danger', text: "Failed to update resume. Please try again." });
        } finally {
            setIsUploadingResume(false);
        }
    };

    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min);
    }


    const connect = async () => {
        if (!selectedJob) {
            alert("Please select a job to interview for.");
            return;
        }

        setLoading(true);
        setStatusMessage({ type: 'info', text: "Scanning your resume against the job description. Please wait..." });

        try {
            // 0. Compare Resume to Job Description first
            const scanRes = await axios.post('/compare_resume_job_description', {
                user_id: user.id,
                job_id: selectedJob
            }, { withCredentials: true });

            if (scanRes.data.status === 'success') {
                const score = scanRes.data.data.matching_score || 0;

                if (score < 30) {
                    setStatusMessage({
                        type: 'danger',
                        text: `Your resume matching score (${score}%) is too low for this role. Please update your resume to match the job requirements before interviewing.`
                    });
                    setLoading(false);
                    return; // Prevent starting the interview
                } else {
                    setStatusMessage({ type: 'success', text: `Resume match successful (${score}%). Starting interview...` });
                }

                // Expose the interview ID generated by the backend
                var interviewId = scanRes.data.interview_id;
            } else {
                setStatusMessage({ type: 'danger', text: "Failed to scan resume. Please try again." });
                setLoading(false);
                return;
            }

            const rName = `interview-${selectedJob}-${getRandomInt(1000, 9999)}`;
            const aName = 'recruiter-agent';
            setRoomName(rName);
            setAgentName(aName);

            // 1. Get LiveKit Token
            const tokenRes = await axios.get(`/getLivekitToken/${rName}/Candidate`, { withCredentials: true });
            const token = tokenRes.data;

            // 2. Start Agent Process Backend
            await axios.post('/start_recruiter_agent', {
                agent_name: aName,
                room_name: rName,
                job_id: selectedJob,
                user_id: user.id,
                interview_id: interviewId
            }, { withCredentials: true });

            // 3. Connect standard LiveKit Room context to the Session
            await room.connect(process.env.REACT_APP_LIVEKIT_URL, token);
            setIsStartConversation(true);

        } catch (err) {
            console.error("Failed to start interview:", err);
            setStatusMessage({ type: 'danger', text: "An error occurred while attempting to start the interview." });
        } finally {
            setLoading(false);
        }
    };

    const stopInterview = async () => {
        setLoading(true);
        setStatusMessage(null);
        try {
            room.disconnect();
            const result = await axios.post("/stop_agent_session", {"room_name": roomName}, { withCredentials: true })
            console.log(result);
            setIsStartConversation(false);
        } catch (error) {
            console.error("Error occurred during stop:", error);
        } finally {setLoading(false);
        }
    };

    return (
        <div className="pt-5 mt-4">
            <Container fluid className="p-2 pt-md-3 pb-md-0 px-lg-5">
                <RoomContext.Provider data-lk-theme="default" value={room}>

                    {!isStartConversation ? (
                        <Row className="mx-auto align-items-start my-md-4 px-lg-5" style={{ minHeight: "60vh" }}>
                            <Col lg={6} className="d-flex flex-column align-items-start mb-4 mb-lg-0 px-lg-5">
                                <div
                                    className="col-12 col-md-8 col-lg-12 mx-auto shadow-sm position-relative overflow-hidden mb-4"
                                    style={{
                                        maxHeight: "500px",
                                        aspectRatio: "1/1",
                                        borderRadius: "24px",
                                        backgroundColor: "#f4f6f8",
                                        border: "4px solid white"
                                    }}>
                                    <img
                                        src="/avatar-meera.webp"
                                        alt="AI Recruiter"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }} />
                                </div>

                                <div className="text-center w-100 mt-4 align-items-center">
                                    <Button
                                        onClick={connect}
                                        className="btn-custom px-5 py-2 fw-bold shadow-sm w-50"
                                        style={{ color: "white", borderRadius: "8px", minWidth: "200px" }}
                                        disabled={loading || isUploadingResume || !selectedJob}
                                    >
                                        {loading ? <span className="d-flex align-items-center fw-semibold justify-content-center gap-2 w-100"><Spinner size="sm" />Starting...</span> : "Start Interview"}
                                    </Button>
                                </div>
                            </Col>

                            {/* Right Column: Roles & Resume */}
                            <Col lg={6} className="text-start py-5">
                                <h5 className='text-custom mb-3 fw-bold'>Welcome, {user.name}</h5>
                                <p className="text-secondary mb-5 fw-semibold">
                                    Select your target role and prepare for your automated screening interview.
                                </p>
                                <div className="mb-4">
                                    <Form.Label className="fw-bold text-dark mb-2">
                                        <i className="bi bi-briefcase-fill me-2 text-custom"></i>
                                        Target Role
                                    </Form.Label>
                                    <Form.Select
                                        value={selectedJob}
                                        onChange={(e) => setSelectedJob(e.target.value)}
                                        disabled={isUploadingResume}
                                        className="shadow-none bg-light"
                                        style={{
                                            borderRadius: "10px",
                                            fontSize: "1rem",
                                            height: "50px",
                                            border: "1px solid #e2e8f0"
                                        }}
                                    >
                                        {jobs.map((job) => (
                                            <option key={job.id} value={job.id}>
                                                {job.title}
                                            </option>
                                        ))}
                                        {jobs.length === 0 && (
                                            <option value="">No jobs available right now.</option>
                                        )}
                                    </Form.Select>
                                </div>

                                <div className="border-top pt-4 mt-2">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <Form.Label className="fw-bold text-dark mb-0">
                                            <i className="bi bi-file-earmark-person-fill me-2 text-custom"></i>
                                            Optional: Update Resume
                                        </Form.Label>
                                        {isUploadingResume && (
                                            <Spinner animation="border" size="sm" className="text-primary" />
                                        )}
                                    </div>

                                    <p className="text-secondary small mb-3">
                                        Your profile resume will be used by default. Upload a new one below if you want to tailor it for this specific interview.
                                    </p>

                                    {uploadedResumeName && (
                                        <div className="mb-3 text-success small fw-medium d-flex align-items-center bg-success bg-opacity-10 p-2 rounded">
                                            <i className="bi bi-check-circle-fill me-2"></i>
                                            <span className="text-dark me-2">Active:</span>
                                            <a
                                                href={`${process.env.REACT_APP_SERVER_URL}/view_resume/${user.id}?v=${resumeVersion}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-custom text-decoration-none"
                                                style={{ maxWidth: "250px", cursor: "pointer" }}
                                                title={`${uploadedResumeName}`}>
                                                {uploadedResumeName}
                                            </a>
                                        </div>
                                    )}

                                    {statusMessage && (
                                        <Alert variant={statusMessage.type} className="py-2 px-3 small border-0 shadow-sm" style={{ borderRadius: "8px" }}>
                                            {statusMessage.text}
                                        </Alert>
                                    )}

                                    <div className="d-flex flex-column flex-sm-row gap-4">
                                        <Form.Control
                                            type="file"
                                            onChange={handleFileChange}
                                            ref={fileInputRef}
                                            disabled={isUploadingResume}
                                            className="bg-light border-0"
                                            style={{
                                                borderRadius: "10px",
                                                border: "1px solid #e2e8f0"
                                            }}
                                        />
                                        <Button
                                            onClick={handleResumeUpload}
                                            disabled={isUploadingResume || !resumeFile}
                                            className="px-4 fw-bold shadow-sm btn-custom w-100"
                                            style={{ borderRadius: "10px", whiteSpace: "nowrap", maxWidth: "100%" }}
                                        >
                                            <i className="bi bi-cloud-arrow-up me-2"></i>Upload
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        <Row className="mx-auto">
                            <Col lg={5} className="mx-auto px-0">
                                <div className="p-3 video-room align-items-center">
                                    <AvatarRenderer
                                        agentName={agentName}
                                        onStop={stopInterview}
                                        loading={loading}
                                    />
                                    <div className="controls" style={{ maxWidth: "700px" }}>
                                        <div className="d-flex align-items-center">
                                            <TrackToggle
                                                className="control-btn rounded-circle mute-btn"
                                                source={Track.Source.Microphone}
                                            />
                                        </div>
                                        <PauseButton />
                                        <Button
                                            className="control-btn rounded-circle text-light text-center position-relative"
                                            variant="danger"
                                            onClick={stopInterview}
                                            disabled={loading}
                                        >
                                            <i className="bi bi-telephone-x-fill fs-6 position-absolute top-50 start-50 translate-middle" />
                                        </Button>
                                    </div>
                                </div>
                            </Col>

                            <Col lg={7} className="mx-auto px-2">
                                <div className="bg-white p-2 rounded shadow-sm h-100 border">
                                    <h5 className="p-3 m-0 border-bottom text-custom fw-bold">
                                        <i className="bi bi-chat-text-fill me-2"></i>Live Transcript
                                    </h5>
                                    <ChatBox />
                                </div>
                            </Col>
                        </Row>
                    )}

                </RoomContext.Provider>
            </Container>
        </div>
    )
}
export default Main;